var map = {
	"./exit-fullscreen.svg": 5010,
	"./eye-open.svg": 5160,
	"./eye.svg": 7591,
	"./fullscreen.svg": 755,
	"./guide.svg": 8739,
	"./hamburger-closed.svg": 4958,
	"./hamburger-opened.svg": 917,
	"./language.svg": 8638,
	"./password.svg": 731,
	"./user.svg": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;